import React from 'react';

import { Checkbox } from '../../../../Shared';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';

const labels = {
  checkboxOne: "Your personal information",
  checkboxTwo: "Classes and students' assignments and progress",
  checkboxThree: "All content you created, including lessons and projects",
};

interface DeleteAccountModalProps {
  cancel: () => void;
  deleteAccount: () => void;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({ cancel, deleteAccount }) => {
  const { modalRef, } = useModalAccessibility(cancel)

  const [checkboxOne, setCheckboxOne] = React.useState(false);
  const [checkboxTwo, setCheckboxTwo] = React.useState(false);
  const [checkboxThree, setCheckboxThree] = React.useState(false);

  const toggleCheckbox = (checkboxNumber: string) => {
    if (checkboxNumber === 'checkboxOne') {
      setCheckboxOne((prev) => !prev);
    } else if (checkboxNumber === 'checkboxTwo') {
      setCheckboxTwo((prev) => !prev);
    } else if (checkboxNumber === 'checkboxThree') {
      setCheckboxThree((prev) => !prev);
    }
  };

  const submitClass = () => {
    let buttonClass = 'quill-button contained medium red focus-on-light';
    if (!(checkboxOne && checkboxTwo && checkboxThree)) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  };

  const renderCheckbox = (checkboxNumber: string) => {
    let selected = false;
    if (checkboxNumber === 'checkboxOne') {
      selected = checkboxOne;
    } else if (checkboxNumber === 'checkboxTwo') {
      selected = checkboxTwo;
    } else if (checkboxNumber === 'checkboxThree') {
      selected = checkboxThree;
    }
    return (
      <Checkbox
        label={labels[checkboxNumber]}
        onClick={() => toggleCheckbox(checkboxNumber)}
        selected={selected}
      />
    );
  };

  const renderCheckboxes = () => (
    <div className="checkboxes">
      {renderCheckbox('checkboxOne')}
      {renderCheckbox('checkboxTwo')}
      {renderCheckbox('checkboxThree')}
    </div>
  );

  return (
    <div>
      <div className="modal-background" />
      <div
        aria-labelledby="deleteAccountModalTitle"
        aria-modal="true"
        className="modal delete-account-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h1 id="deleteAccountModalTitle">Delete your Quill account</h1>
        <p>
          When we remove your account, the following information will be permanently deleted.
          Please check each box to confirm your understanding.
        </p>
        {renderCheckboxes()}
        <div className="button-section">
          <button
            className="quill-button outlined medium grey focus-on-light"
            id="cancel"
            onClick={cancel}
            type="button"
          >
            Cancel
          </button>
          <button
            className={submitClass()}
            name="commit"
            onClick={deleteAccount}
            type="submit"
          >
            Delete account
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
